'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const PageViewsChart = dynamic(() => import('./PageViewsChart'), { ssr: false });

export default function DashboardChartSection() {
  return (
    <div className="bg-card rounded-2xl p-6 border border-border card-shadow">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-base font-700 text-foreground">Page Views</h3>
          <p className="text-sm text-muted-foreground mt-0.5">Last 7 days</p>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 rounded-full bg-primary" />
            <span className="text-xs text-muted-foreground font-500">Views</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 rounded-full bg-success" />
            <span className="text-xs text-muted-foreground font-500">Clicks</span>
          </div>
        </div>
      </div>
      <PageViewsChart />
    </div>
  );
}